module.exports = __webpack_public_path__ + "img/banner-1.f72014bd.jpg";